/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SuccessfulResponse as DigiworkMaitreDApiConfigurationModelSuccessfulResponse } from '../../models/Digiwork/MaitreD/Api/Configuration/Model/successful-response';
import { CreateSplitBillDto as DigiworkMaitreDPosDtoOrderV2CreateSplitBillDto } from '../../models/Digiwork/MaitreD/Pos/DTO/OrderV2/create-split-bill-dto';

export interface CreateSplitBill$Params {
  billId: string;
      body?: DigiworkMaitreDPosDtoOrderV2CreateSplitBillDto
}

export function createSplitBill(http: HttpClient, rootUrl: string, params: CreateSplitBill$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDApiConfigurationModelSuccessfulResponse>> {
  const rb = new RequestBuilder(rootUrl, createSplitBill.PATH, 'post');
  if (params) {
    rb.path('billId', params.billId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DigiworkMaitreDApiConfigurationModelSuccessfulResponse>;
    })
  );
}

createSplitBill.PATH = '/api/orders/bills/{billId}/split-bill';
